export const messages = {
  en: {
    repairDetail: {
      title: 'Work Order Details',
      print: 'Print',
      back: 'Back',
      orderCode: 'Work Order Code:',
      repairType: 'Repair Type:',
      repairer: 'Repairer:',
      contact: 'Contact:',
      location: 'Location:',
      appointmentStart: 'Appointment Start:',
      appointmentEnd: 'Appointment End:',
      submitDuration: 'Submission Duration:',
      finishTime: 'Completion Time:',
      status: 'Status:',
      content: 'Content:',
      maintenanceType: 'Maintenance Type:',
      materials: 'Materials:',
      costDetail: 'Cost Details:',
      yuan: 'Yuan (Unit Price * Quantity)',
      avgScore: 'Average Score:',
      comprehensiveScore: 'Comprehensive Score:',
      doorSpeedScore: 'Door Speed Score:',
      serviceScore: 'Service Score:',
      points: 'Points',
      visitSatisfaction: 'Visit Satisfaction:',
      visitContent: 'Visit Content:',
      orderPhotos: 'Order Photos',
      orderFlow: 'Order Flow',
      orderEvents: 'Order Events',
      repairItems: 'Repair Items',
      paidService: 'Paid Service',
      freeService: 'Free Service',
      needMaterials: 'Need Materials',
      noMaterials: 'No Materials',
      beforeRepairPhotos: 'Before Repair Photos',
      afterRepairPhotos: 'After Repair Photos'
    },
    repairDetailResource: {
      itemCode: 'Item Code',
      itemType: 'Item Type',
      itemName: 'Item Name',
      specification: 'Specification',
      quantity: 'Quantity',
      price: 'Price',
      user: 'User',
      time: 'Time'
    },
    repairDetailUser: {
      serial: 'Serial',
      handler: 'Handler',
      status: 'Status',
      startTime: 'Start Time',
      endTime: 'End Time',
      duration: 'Duration',
      opinion: 'Opinion',
      reply: 'Reply'
    },
    repairDetailEvent: {
      eventType: 'Event Type',
      staff: 'Staff',
      description: 'Description',
      createTime: 'Create Time'
    },
    replyRepairAppraise: {
      title: 'Reply Evaluation',
      content: 'Content',
      submit: 'Submit',
      cancel: 'Cancel',
      placeholder: 'Required, please fill in reply content'
    }
  },
  zh: {
    repairDetail: {
      title: '工单详情',
      print: '打印',
      back: '返回',
      orderCode: '工单编码：',
      repairType: '报修类型：',
      repairer: '报修人：',
      contact: '联系方式：',
      location: '位置：',
      appointmentStart: '预约开始时间：',
      appointmentEnd: '预约结束时间：',
      submitDuration: '提单时长：',
      finishTime: '完成时间：',
      status: '状态：',
      content: '报修内容：',
      maintenanceType: '维修类型：',
      materials: '用料：',
      costDetail: '费用明细：',
      yuan: '元(单价*数量)',
      avgScore: '平均分：',
      comprehensiveScore: '综合评价得分：',
      doorSpeedScore: '上门速度评分：',
      serviceScore: '维修员服务评分：',
      points: '分',
      visitSatisfaction: '回访满意度：',
      visitContent: '回访内容：',
      orderPhotos: '工单图片',
      orderFlow: '工单流转',
      orderEvents: '工单事件',
      repairItems: '维修物品',
      paidService: '有偿服务',
      freeService: '无偿服务',
      needMaterials: '需要用料',
      noMaterials: '无需用料',
      beforeRepairPhotos: '维修前照片',
      afterRepairPhotos: '维修后照片'
    },
    repairDetailResource: {
      itemCode: '物品资源编号',
      itemType: '物品资源类型',
      itemName: '物品资源名称',
      specification: '物品资源规格',
      quantity: '物品使用数量',
      price: '物品价格',
      user: '使用人',
      time: '时间'
    },
    repairDetailUser: {
      serial: '序号',
      handler: '处理人',
      status: '状态',
      startTime: '处理开始时间',
      endTime: '处理结束时间',
      duration: '耗时',
      opinion: '意见',
      reply: '回复'
    },
    repairDetailEvent: {
      eventType: '事件类型',
      staff: '员工',
      description: '事件说明',
      createTime: '创建时间'
    },
    replyRepairAppraise: {
      title: '回复评价',
      content: '内容',
      submit: '提交',
      cancel: '取消',
      placeholder: '必填，请填写回复内容'
    }
  }
}